import { useContext, useEffect, useState } from 'react'

import { EditContext } from 'Components/Hooks/ContextEdit'
import CustomButton from 'Components/UI/Atoms/CustomButton'
// import Contact from "../Contact"
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import ContentWithSubTabs from 'Components/UI/Molecules/ContentWithSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import useStyles from 'Components/UI/Organisms/Vehicles/Quotations/Edit/Fields/Home/styles'
import { interfaces } from 'service/interfaces'

import Contact from './Contact'
import { DATOS_EXTRA } from './DatosExtra'
import { INF_GRAL_FIELDS } from './InfGralFields'

const HomeContent = (props) => {
  const { data, setData, onDataChange, changeStatus, dataBefore } = props
  const [edit] = useContext(EditContext)
  const [cuentas, setCuentas] = useState()

  const [tab, setTab] = useState(0)

  const createDismissableSnackbar = useCustomSnackbar()

  const handleChange = (name, value) => {
    if (name === 'domicilio') {
      if (value.trim() === '') {
        createDismissableSnackbar('La dirección no puede estar vacía', {
          variant: 'error',
        })
      }
    }
    setData((prevData) => ({
      ...prevData,
      infoClient: {
        ...prevData.infoClient,
        [name]: value,
      },
    }))
  }

  const classes = useStyles()

  async function cuentasData() {
    await interfaces.salesClients.cuentas().then((res) => {
      setCuentas(res.data)
    })
  }

  useEffect(() => {
    cuentasData()
  }, [tab])

  function renderTabs(index) {
    switch (index) {
      case 0:
        return (
          <>
            <InputsWithoutValidate
              fields={INF_GRAL_FIELDS(
                data.infoClient,
                handleChange,
                edit,
                dataBefore.data.permissions
              )}
              spacing={2}
            />
            <div className={classes.buttons} style={{ marginTop: '10px' }}>
              {/* // CAMBIAR BACKGROUND */}
              {dataBefore.data.permissions.allowIncobrable && (
                <CustomButton
                  buttonEnd
                  style={{
                    marginLeft: '1.5rem',
                    backgroundColor:
                      data.infoClient.estado === 'INHABILITADO' ? '#e0e0e0' : '#cc3030',
                  }}
                  text={
                    data.infoClient.estado === 'INCOBRABLE' ? 'Quitar incobrable' : 'Incobrable'
                  }
                  onClick={() =>
                    changeStatus(data.infoClient.estado === 'INCOBRABLE' ? 'Activo' : 'Incobrable')
                  }
                  disabled={data.infoClient.estado === 'INHABILITADO'}
                />
              )}

              {dataBefore.data.permissions.allowBloquear && (
                <CustomButton
                  buttonEnd
                  style={{
                    marginLeft: '1.5rem',
                    backgroundColor:
                      (data.infoClient.estado !== 'Activo' &&
                        data.infoClient.estado !== 'BLOQUEADO') ||
                      (data.infoClient.estado === 'BLOQUEADO' &&
                        data.ctaCliente.saldos.dias_atraso >= 30)
                        ? '#e0e0e0'
                        : '#cc3030',
                  }}
                  text={data.infoClient.estado === 'BLOQUEADO' ? 'Desbloquear' : 'Bloquear'}
                  onClick={() =>
                    changeStatus(data.infoClient.estado === 'BLOQUEADO' ? 'Activo' : 'Bloqueado')
                  }
                  disabled={
                    (data.infoClient.estado !== 'Activo' &&
                      data.infoClient.estado !== 'BLOQUEADO') ||
                    (data.infoClient.estado === 'BLOQUEADO' &&
                      data.ctaCliente.saldos.dias_atraso >= 30)
                  }
                />
              )}

              {dataBefore.data.permissions.allowDeshabiliar && (
                <CustomButton
                  buttonEnd
                  color="primary"
                  style={{
                    marginLeft: '1.5rem',
                    backgroundColor:
                      data.infoClient.estado === 'Activo'
                        ? '#707070e6'
                        : data.infoClient.estado === 'BLOQUEADO' &&
                            data.ctaCliente.saldos.dias_atraso >= 30
                          ? '#e0e0e0'
                          : '#3e984c',
                  }}
                  text={data.infoClient.estado === 'Activo' ? 'Deshabilitar' : 'Habilitar'}
                  onClick={() =>
                    changeStatus(data.infoClient.estado === 'Activo' ? 'Inhabilitado' : 'Activo')
                  }
                  disabled={
                    data.infoClient.estado === 'BLOQUEADO' &&
                    data.ctaCliente.saldos.dias_atraso >= 30
                  }
                />
              )}
            </div>
          </>
        )
      case 1:
        return <Contact data={data} onDataChange={onDataChange} />
      case 2:
        return (
          <InputsWithoutValidate
            fields={DATOS_EXTRA(
              data.infoClient,
              handleChange,
              edit,
              cuentas,
              dataBefore.data.permissions
            )}
            spacing={2}
          />
        )
      default:
        break
    }
  }

  const verticalTabs = [
    {
      id: 0,
      title: 'Información general',
    },
    {
      id: 1,
      title: 'Datos de contacto',
    },
    {
      id: 2,
      title: 'Datos extras',
    },
  ]

  return (
    <div>
      <ContentWithSubTabs
        listVerticalTabs={verticalTabs}
        value={tab}
        setValue={setTab}
        children={<div style={{ margin: '20px' }}>{renderTabs(tab)}</div>}
      />
    </div>
  )
}

export default HomeContent
